module.exports = __webpack_public_path__ + "static/media/worldmap.dc18ea9c.svg";